import { Grade } from "@/api/resources/teachers/types"

export type GradeDisplayProps = {
  grade: Grade
  hideLabel?: boolean
}

const GRADE_LEVELS: Record<Grade, number> = {
  [Grade.Band1]: 1,
  [Grade.Band2]: 2,
  [Grade.Band3]: 3,
  [Grade.Band4]: 4,
  [Grade.Band5]: 5,
}

const GRADE_TEXTS: Record<Grade, string> = {
  [Grade.Band1]: "B1",
  [Grade.Band2]: "B2",
  [Grade.Band3]: "B3",
  [Grade.Band4]: "B4",
  [Grade.Band5]: "B5",
}

const BOX_GRADIENTS = [
  "bg-[linear-gradient(270.17deg,_#14151B_-433.05%,_#050F3A_-325.17%,_#1B308E_-251.14%,_#C99CE5_99.86%)]", // B1 color
  "bg-[linear-gradient(270.17deg,_#14151B_-323.36%,_#050F3A_-215.71%,_#1B308E_-141.84%,_#C99CE5_208.43%)]", // B2 color
  "bg-[linear-gradient(270.17deg,_#14151B_-214.79%,_#050F3A_-107.13%,_#1B308E_-33.26%,_#C99CE5_317.01%)]", // B3 color
  "bg-[linear-gradient(270.17deg,_#14151B_-105.11%,_#050F3A_1.88%,_#1B308E_75.28%,_#C99CE5_423.36%)]", // B4 color
  "bg-[linear-gradient(270.17deg,_#14151B_0.14%,_#050F3A_108.25%,_#1B308E_182.43%,_#C99CE5_534.16%)]", // B5 color
]

const GRADE_TOOLTIPS: Record<
  Grade,
  {
    title: string
    subtitle: string
  }
> = {
  [Grade.Band1]: {
    title: "B1: Emerging",
    subtitle: "Demonstrates basic understanding. Requires significant support.",
  },
  [Grade.Band2]: {
    title: "B2: Developing",
    subtitle: "Shows partial understanding. Needs continuous mentoring.",
  },
  [Grade.Band3]: {
    title: "B3: Competent",
    subtitle: "Adequately meets teaching expectations.",
  },
  [Grade.Band4]: {
    title: "B4: Proficient",
    subtitle: "Strong and consistent demonstration of teaching practices.",
  },
  [Grade.Band5]: {
    title: "B5: Advanced",
    subtitle: "Exemplifies best teaching practices.",
  },
}

export { BOX_GRADIENTS, Grade, GRADE_LEVELS, GRADE_TEXTS, GRADE_TOOLTIPS }
